import React, { useState } from 'react';
import { NButton } from '@innersource-nn/novoui-react';
import { RequestAccessFormData } from 'types/Forms';
import AutocompleteTooltip, {
    Option,
} from 'components/Inputs/InputsWithTooltip/AutocompleteTooltip';
import useDatasetListLabels from 'views/Datasets/hooks/useDatasetLabels';
import SimpleLoader from 'components/loader/SimpleLoader';
interface SelectDatasetStepProps {
    count: number;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
    formData: RequestAccessFormData;
    setFormData: React.Dispatch<React.SetStateAction<RequestAccessFormData>>;
}

interface SelectedDataset {
    label: string;
    name: string;
}

export default function SelectDatasetStep({
    count,
    setActiveStep,
    formData,
    setFormData,
}: SelectDatasetStepProps) {
    const [datasetError, setDatasetError] = useState('');
    const [value, setValue] = useState(formData.datasetLabel);

    const handleSelected = (selectedDataset: SelectedDataset | Option) => {
        if (selectedDataset.name) {
            setFormData({
                datasetLabel: selectedDataset.label,
                datasetUri: selectedDataset.name,
            });
        } else {
            setDatasetError(
                'There is a problem with the dataset, please try with another one',
            );
        }
    };

    const { datasetLabels, loadingLabels } = useDatasetListLabels({
        count,
        setDatasetError,
    });

    return (
        <div>
            {loadingLabels ? (
                <SimpleLoader />
            ) : (
                <AutocompleteTooltip
                    label="Dataset"
                    placeholder="Search for dataset...."
                    tooltip="Select the datset you want to request access to"
                    items={datasetLabels.map((item) => ({
                        ...item,
                        name: item.uri,
                    }))}
                    value={value}
                    handleSelected={handleSelected}
                    error={datasetError}
                    onChange={(e) => setValue(e.target.value)}
                />
            )}
            <NButton
                variant="fill"
                square
                className="bg-sea-blue-600 mt-8"
                onClick={() => setActiveStep(1)}
                disabled={
                    loadingLabels ||
                    datasetError !== '' ||
                    formData.datasetUri === ''
                }
            >
                Next step
            </NButton>
        </div>
    );
}
